import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { parseGasPrice } from "../../../../../utils/warehouses/parseGasPrice.js";
import { GasPriceContainer, GasDollarsAndCents, GasFractionDigit, GasUnitDescription } from "./styles.js";
const GasPrice = ({ price, label }) => {
  if (!price || !label) {
    return null;
  }
  const parsedPrice = parseGasPrice(price);
  const displayFraction = parsedPrice.fraction !== "0";
  if (!parsedPrice.dollars) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(GasPriceContainer, { children: [
      /* @__PURE__ */ jsx(GasDollarsAndCents, { children: `$${parsedPrice.dollars}` }),
      displayFraction && /* @__PURE__ */ jsx(GasFractionDigit, { children: parsedPrice.fraction })
    ] }),
    /* @__PURE__ */ jsx(GasUnitDescription, { children: label })
  ] });
};
export {
  GasPrice
};
